import { CSSProperties, HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

import { SectionDefinition } from '@/data/shared'

interface SectionLayoutProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  innerClassName?: string
  fullWidth?: boolean
  align?: SectionDefinition<'attributes'>['verticalAlignment']
  screens?: number | null
  narrow?: boolean
  spaceBetweenContentBlocks?: boolean
}

const vert = { top: 'justify-stretch', middle: 'justify-center', bottom: 'justify-end' } as const

export function SectionLayout({
  children,
  className,
  innerClassName,
  fullWidth,
  align,
  screens,
  narrow,
  spaceBetweenContentBlocks,
  ...props
}: SectionLayoutProps) {
  const minHeight = screens ? `${(Number(screens) || 0) * 100}lvh` : 0
  return (
    <div className={twMerge('relative flex w-full flex-1 justify-center', className)} {...props}>
      <div
        className={twMerge(
          'flex h-full min-h-[--minHeight] w-full flex-1 flex-col',
          spaceBetweenContentBlocks && 'gap-y-16 pb-36 pt-6',
          fullWidth ? 'max-w-none' : narrow ? 'max-w-5xl px-10 lg:ml-40 xl:mr-40' : 'max-w-7xl px-5 md:px-10',
          vert[align ?? 'top'],
          innerClassName,
        )}
        style={{ '--minHeight': minHeight } as CSSProperties}
      >
        {children}
      </div>
    </div>
  )
}
